import styled, { css } from 'styled-components';
import { theme } from './theme';

export const Container = styled.div`
  width: 100%;
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: ${props => props.py || 0} 0;
`;

export const Heading = styled.h1`
  font-family: ${props => props.theme.typography.heading.fontFamily};
  font-weight: ${props => props.theme.typography.heading.fontWeight};
  line-height: ${props => props.theme.typography.lineHeights.heading};
  margin-bottom: ${props => props.$mb || props.theme.spacing.md};
  color: ${props => props.color || props.theme.colors.text};
  ${props => props.$maxWidth && css`max-width: ${props.$maxWidth};`}
  ${props => props.$align && css`text-align: ${props.$align};`}

  ${props => {
    switch (props.as) {
      case 'h1':
        return css`font-size: ${props.theme.typography.sizes.h1};`;
      case 'h2':
        return css`font-size: ${props.theme.typography.sizes.h2};`;
      case 'h3':
        return css`font-size: ${props.theme.typography.sizes.h3};`;
      case 'h4':
        return css`font-size: ${props.theme.typography.sizes.h4};`;
      case 'h5':
        return css`font-size: ${props.theme.typography.sizes.h5};`;
      case 'h6':
        return css`font-size: ${props.theme.typography.sizes.h6};`;
      default:
        return css`font-size: ${props.size || props.theme.typography.sizes.h3};`;
    }
  }}
`;

export const Text = styled.p`
  font-family: ${props => props.theme.typography.body.fontFamily};
  font-weight: ${props => props.weight || props.theme.typography.body.fontWeight};
  line-height: ${props => props.theme.typography.lineHeights.body};
  margin-bottom: ${props => props.mb || props.theme.spacing.md};
  color: ${props => props.color || props.theme.colors.text};
  font-size: ${props => {
    switch (props.size) {
      case 'large':
        return props.theme.typography.sizes.bodyLarge;
      case 'small':
        return props.theme.typography.sizes.bodySmall;
      default:
        return props.theme.typography.sizes.body;
    }
  }};
`;

const buttonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.xl};
  border-radius: 100vh;
  font-family: ${props => props.theme.typography.body.fontFamily};
  font-weight: 600 !important;
  font-size: ${props => props.theme.typography.sizes.body};
  line-height: 1;
  text-align: center;
  cursor: pointer;
  transition: all ${props => props.theme.transitions.default};
  white-space: nowrap;
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(143, 228, 198, 0.4);
  }
`;

export const Button = styled.button`
  ${buttonBase}
  background-color: ${props => props.theme.colors.brand};
  color: ${props => props.theme.colors.text};
  border: none;

  &:hover {
    background-color: ${props => props.theme.colors.brandHover};
  }

  &:active {
    background-color: ${props => props.theme.colors.brandPressed};
  }

  ${props => props.$secondary && css`
    background-color: ${props.theme.colors.background};
    border: 1.5px solid ${props.theme.colors.border};
    color: ${props.theme.colors.text};

    &:hover {
      background-color: ${props.theme.colors.brand};
      border-color: ${props.theme.colors.brand};
    }

    &:active {
      background-color: ${props.theme.colors.brandPressed};
      border-color: ${props.theme.colors.brandPressed};
    }
  `}

  ${props => props.$secondary && props.$dark && css`
    background-color: ${props.theme.colors.dark.background};
    border: 1.5px solid ${props.theme.colors.dark.border};
    color: ${props.theme.colors.dark.text};

    &:hover {
      background-color: ${props.theme.colors.brand};
      border-color: ${props.theme.colors.brand};
      color: ${props.theme.colors.text};
    }
  `}

  ${props => props.$small && css`
    padding: ${props.theme.spacing.sm} ${props.theme.spacing.lg};
    font-size: ${props.theme.typography.sizes.bodySmall};
  `}

  ${props => props.$large && css`
    padding: ${props.theme.spacing.lg} ${props.theme.spacing.xxl};
    font-size: ${props.theme.typography.sizes.bodyLarge};
  `}
`; 